import { FC, useEffect } from 'react';
import { useRouteError } from 'react-router';
import { Button } from '@dynamon-as/ui';
import styles from './ErrorPage.module.css';

const RELOAD_FLAG = 'chunk_reload_attempted';

const CHUNK_LOAD_ERROR_PATTERNS = [
    'failed to fetch dynamically imported module',
    'error loading dynamically imported module',
    'loading chunk',
] as const;

type ChunkErrorPattern = (typeof CHUNK_LOAD_ERROR_PATTERNS)[number];

const isChunkLoadError = (error: unknown): boolean =>
    error instanceof Error &&
    CHUNK_LOAD_ERROR_PATTERNS.some((pattern: ChunkErrorPattern) =>
        error.message.toLowerCase().includes(pattern),
    );

const ErrorPage: FC = () => {
    const error = useRouteError();

    useEffect(() => {
        if (isChunkLoadError(error) && !sessionStorage.getItem(RELOAD_FLAG)) {
            sessionStorage.setItem(RELOAD_FLAG, 'true');
            window.location.reload();
        }
    }, [error]);

    return (
        <div className={styles.container}>
            <h1 className={styles.heading}>Noe gikk galt</h1>
            <p className={styles.message}>
                En uventet feil har oppstått. Vennligst prøv å laste siden på
                nytt.
            </p>
            <div className={styles.actions}>
                <Button
                    text="Gå til forsiden"
                    variant="outlined"
                    onClick={() => (window.location.href = '/')}
                />
                <Button
                    text="Last inn på nytt"
                    onClick={window.location.reload}
                />
            </div>
        </div>
    );
};

export default ErrorPage;
